import { render } from "./FormLabel.vue?vue&type=template&id=f39d08d2"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FormLabel.vue"]])

export default __exports__